export default {
  gallery: 'Galleri',
  download_success_single: 'Albummet blev downloadet',
  download_success_multiple: 'Albummerne blev downloadet',
  download_error: 'Download kunne ikke gennemføres da en eller flere medier ikke længere eksisterer',
  delete_success_single: 'Albummet blev slettet',
  delete_success_multiple: 'Albummerne blev slettet',
  delete_error_single: 'Kunne ikke slette albummet',
  delete_error_multiple: 'Ikke alle valgte albummer kunne slettes',
  albums: 'albummet | albummerne',
  album: 'Album',
  album_description: 'Albumbeskrivelse',
};
